import { businessService } from '../services/api/businessService';

/**
 * Resolve display names for business IDs (single list fetch).
 * @param {string[]} businessIds
 * @returns {Promise<Record<string, string>>}
 */
export async function fetchBusinessNamesByIds(businessIds) {
  const unique = [...new Set((businessIds || []).filter(Boolean))];
  if (!unique.length) return {};

  try {
    const all = await businessService.getAllBusinesses();
    const byId = new Map(
      (all || []).map((biz) => [biz.BusinessId, biz.BusinessName || 'Business']),
    );
    return Object.fromEntries(
      unique.map((id) => [id, byId.get(id) || 'Business']),
    );
  } catch {
    return Object.fromEntries(unique.map((id) => [id, 'Business']));
  }
}
